import { Field, useField } from 'formik';
import { ErrorDisplay, RadioButton } from '@/components/formComponents/';
import { Dispatch, SetStateAction } from 'react';

interface CheckboxProps {
    name: string;
    options?: string[];
    onClick?: Dispatch<SetStateAction<string>>;
}
const RadioButtonGroup = (props: CheckboxProps) => {
    const [, meta] = useField(props.name);
    const radios = props.options?.map((option: string) => (
        // <label className="mr-2" key={option}>
        <Field
            component={RadioButton}
            name={props.name}
            id={option}
            label={option}
            onClick={props.onClick}
            className="mr-2"
            key={option}
        />
        // </label>
    ));

    return (
        <div className="flex">
            <div
                role="group"
                aria-labelledby="my-radio-group"
                className="flex p-4 justify-center items-center"
            >
                {radios}
            </div>
            <ErrorDisplay meta={meta} />
        </div>
    );
};

export default RadioButtonGroup;
